import * as React from 'react';
import classNames from 'classnames';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import Select from '../../../../shared/components/Select';
import ConstructionAutocomplete from '../../../../shared/components/ConstructionAutocomplete';
import CompanyAutocomplete from '../../../../shared/components/CompanyAutocomplete';
import PropTypes from 'prop-types';

export class HeaderFilterOptions extends React.Component {

    constructionAutocompleteRef;
    companyAutocompleteRef;

    componentDidUpdate(prevProps) {
        const nextYear = this.props.filters.year();
        const nextMonth = this.props.filters.month();
        if ( prevProps.filters.yearOrMonthHasChanged(nextYear, nextMonth) ) {
            this.constructionAutocompleteRef.getInstance().clear();
            this.companyAutocompleteRef.getInstance().clear();
        }
    }

    handleConstructionAutocompleteRef = (node) => {
        this.constructionAutocompleteRef = node;
    };

    handleCompanyAutocompleteRef = (node) => {
        this.companyAutocompleteRef = node;
    };

    render() {
        const {
            years,
            months,
            filters,
            handleChangeYearFilter,
            handleChangeMonthFilter,
            handleSelectWorkFilter,
            handleSelectOutsourceFilter,
        } = this.props;

        const selectFieldClass = classNames(
            'form-control',
            'show-tick',
            'bootstrap-select',
        );

        const disabledMonthField = !filters.hasYear();
        const disabledMonthFieldClass = classNames({ 'disabled': disabledMonthField });
        const monthFieldClass = classNames(selectFieldClass, disabledMonthFieldClass);
        const invalidDate = filters.invalidYearMonth();
        const disabledFieldClass = classNames({ 'disabled': invalidDate });

        return (
            <div className="row">
                <div className="col-sm-3">
                    <label>{I18nUtils.tr('TR_ANYO')}:</label>
                    <Select
                        className={selectFieldClass}
                        options={years}
                        value={filters.year()}
                        disabled={false}
                        onChange={handleChangeYearFilter}
                    />
                </div>
                <div className="col-sm-3">
                    <label className={disabledMonthFieldClass}>
                        {I18nUtils.tr('TR_MES')}:
                    </label>
                    <Select
                        className={monthFieldClass}
                        options={months}
                        value={filters.month()}
                        disabled={disabledMonthField}
                        onChange={handleChangeMonthFilter}
                    />
                </div>
                <div className="col-sm-3">
                    <label className={disabledFieldClass}>
                        {I18nUtils.tr('TR_OBRA')}:
                    </label>
                    <ConstructionAutocomplete
                        className={disabledFieldClass}
                        disabled={invalidDate}
                        onChange={(selectedWork) => handleSelectWorkFilter(selectedWork[0])}
                        handleTypeaheadRef={this.handleConstructionAutocompleteRef}
                    />
                </div>
                <div className="col-sm-3">
                    <label className={disabledFieldClass}>
                        {I18nUtils.tr('TR_SUBCONTRATA')}:
                    </label>
                    <CompanyAutocomplete
                        className={disabledFieldClass}
                        company={filters.outsource()}
                        disabled={invalidDate}
                        onChange={(selectedOutsource) => handleSelectOutsourceFilter(selectedOutsource[0])}
                        handleTypeaheadRef={this.handleCompanyAutocompleteRef}
                    />
                </div>
            </div>
        );
    }
}

HeaderFilterOptions.propTypes = {
    years: PropTypes.array,
    months: PropTypes.array,
    works: PropTypes.array,
    filters: PropTypes.object,
};

HeaderFilterOptions.defautlProps = {
    years: [],
    months: [],
    works: [],
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/monthly/components/HeaderFilterOptions.jsx